<!-- 亚专业文章列表 -->
<template>
	<div>
		<row-item-list :list="articlesList" v-if="hasData"></row-item-list>
		<van-empty description="暂无数据"  v-else></van-empty>
	</div>
</template>
<script>
	import {CaseArticles} from '../../config/interface.js';
	import RowItemList from "../../components/RowItemList"
	export default{
		components:{
				RowItemList
		},
		data(){
			return{
				articlesList:[],        //文章列表
				subspecialty_id:0,		//亚专业id
				hasData:true,
			}
		},
		mounted(){
			this.subspecialty_id=this.$route.query.id;
			this.getArticlesList();
		},
		methods:{
			//得到亚专业文章列表
			getArticlesList(){
				this.$store.dispatch('isShowLoading',true);
				const url=CaseArticles;
				let params={
					subspecialty_id:this.subspecialty_id
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let readnum=data.readnum;
						data.articles.forEach(function(item,index){
							item.readnum=readnum[item.id];
						})
						this.articlesList=data.articles;
						this.hasData=this.articlesList.length>0?true:false;
					}
					this.$store.dispatch('isShowLoading',false);
				})
			}
		}
	}
</script>
<style lang="scss">
	
</style>



// WEBPACK FOOTER //
// src/pages/Case/list.vue